import React from 'react';
import PropTypes from 'prop-types';
import { EmojiIcon } from '../EmojiIcon';
import { calculateProfileScore, getArchetype } from '../../shared/profile-score-helpers';
import styles from './ProfileSlide.css';

const MAX_SCORE = 100;

const ARCHETYPES = [
    {
        maxScore: 52,
        title: 'Still Waters',
        emoji: 'water-wave',
        description: 'Not every rich life is loud. Your answers point to meaning in the quieter moments — the ones that are easy to overlook.'
    },
    {
        maxScore: 70,
        title: 'The Long Way Round',
        emoji: 'winding-road',
        description: 'Plans changed. You changed with them. Your answers show a life shaped as much by detours as by destinations.'
    },
    {
        maxScore: 100,
        title: 'A Life and a Half',
        emoji: 'roller-coaster',
        description: 'Your answers reveal a life full of moments, turns, and memories — with more than enough to fill many chapters.'
    }
];

function ProfileSlide({ spriteVersion, results }) {
    const score = calculateProfileScore(results.userResponses);
    const gaugePercent = Math.min(Math.max(score, 0), MAX_SCORE);
    const archetype = getArchetype(score, ARCHETYPES);

    return (
        <div className={styles.root}>
            <h1 className={styles.title}>
                {'Your '}<em>Life Richness Profile</em>{' report'}
            </h1>
            <div className={styles.cards}>
                <div className={styles.card}>
                    <p className={styles.label}>Your Life Richness Score</p>
                    <div className={styles.scoreSection}>
                        <div className={styles.scoreRow}>
                            <span className={styles.score}>{score}</span>
                            <span className={styles.scoreMax}>{`/${MAX_SCORE}`}</span>
                        </div>
                        <div className={styles.gaugeWrap}>
                            <div className={styles.gaugeTrack}>
                                <div className={styles.gaugeFill} style={{ width: `${gaugePercent}%` }} />
                                <div className={styles.gaugeThumb} style={{ left: `${gaugePercent}%` }} />
                            </div>
                            <div className={styles.gaugeLabels}>
                                <span>Quiet</span>
                                <span>Rich</span>
                            </div>
                        </div>
                    </div>
                </div>
                <div className={styles.card}>
                    <p className={styles.label}>Your archetype</p>
                    <p className={styles.archetypeTitle}>
                        {archetype.title}
                        {archetype.emoji && <EmojiIcon name={archetype.emoji} version={spriteVersion} className={styles.emoji} />}
                    </p>
                    <p className={styles.archetypeDescription}>
                        {archetype.description}
                    </p>
                </div>
            </div>
        </div>
    );
}

ProfileSlide.propTypes = {
    spriteVersion: PropTypes.string.isRequired,
    results: PropTypes.shape({
        userResponses: PropTypes.array
    }).isRequired
};

export {
    ProfileSlide
};
